export const ERRORS = {
  staleContent: 'The content you are editing has changed. Please copy your edits and exit the editor.',
}
